export const getCustomBtnToUseOnSlideShow = async (data = {}) =>{
    
    const setTxtV2 = (await import(/* webpackPrefetch: true */ `./../../classes/universal_methods/setTxtV2.js`)).setTxtV2;

    const  {text, icon} = data;

    const directionTxt = setTxtV2({
        attributes: {},
        txt: text,
        type: "html"
    });

    return `
        <p class="smetio-flex-row smetio-align-center "> 
            <i class=" smetio-margin-right-5 smetio-icon smetio-icon-${icon}"></i> 
            <span class="smetio-margin-left-5"> ${directionTxt} </span> 
        </p>
    `;

};
